// @ts-nocheck
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles, spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export interface AttributesProps {
    wrapper?: InjectableCss;
    container?: GridContainerProps;
    innerWrapper?: InjectableCss;
    item?: GridItemProps;
    label?: TypographyPresentationProps;
    value?: TypographyPresentationProps;
    // Store Custom Code
    count?: TypographyPresentationProps;
}

export const attributeSpacing = pxToRem(3);

export const baseStyles = () => css`
    color: ${getColor("text") /* Store Custom Code */};

    ${({ theme }) => css`
        font-size: ${theme.design.typography.size.smallest};
        line-height: ${theme.design.typography.lineHeight.semi};
    `}
`;

export const attributesProps: AttributesProps = {
    wrapper: {
        css: css`
            display: block;
            ${baseStyles()}
        `,
    },
    container: {
        gap: 0,
        css: css`
            ${gridGapStyles([], [attributeSpacing])}
            ${baseStyles()}
        `,
    },
    innerWrapper: {
        css: css`
            display: inline-flex; /* Store Custom Code */
            ${spacingStyles(null, attributeSpacing)}
            /* Store Custom Code - Start */
            max-width: 100%;
            white-space: nowrap;
            /* Store Custom Code - End */
        `,
    },
    item: {
        width: 12,
        css: css`
            flex-flow: wrap;
        `,
    },
    label: {
        css: css`
            margin-right: 0.3em;
        `,
    },
    value: {
        css: css`
            word-break: break-all;
            /* Store Custom Code - Start */
            overflow: hidden;
            text-overflow: ellipsis;
            /* Store Custom Code - End */
        `,
    },
    /* Store Custom Code - Start */
    count: {
        css: css`
            display: inline-flex;
            align-items: center;
            justify-content: center;
            height: ${pxToRem(18)};
            padding: ${pxToRem(0, 4)};
            background-color: ${getColor("info.lightest")};
            color: ${getColor("info")};
            border-radius: ${pxToRem(2)};
            font-size: ${x => x.theme.design.typography.size.tiny};
            font-weight: ${x => x.theme.design.typography.weight.bold};
            line-height: 1;
            margin: ${pxToRem(-1, 0, 0, 4)};
        `,
    },
    /* Store Custom Code - End */
};
